import type { ReactNode } from 'react'
import { cn } from '@/lib/cn'
import styles from './Bento.module.css'

export function BentoGrid({
  className,
  children,
}: {
  readonly className?: string | undefined
  readonly children: ReactNode
}) {
  return <div className={cn(styles.grid, className)}>{children}</div>
}

export function BentoSpan({
  span = 1,
  className,
  children,
}: {
  readonly span?: 1 | 2 | 3 | 4 | undefined
  readonly className?: string | undefined
  readonly children: ReactNode
}) {
  const spanClass = span === 1 ? undefined : styles[`span${span}`]
  return <div className={cn(spanClass, className)}>{children}</div>
}
